import { Switch } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { fetchActiveConfigIdForMachine, updateConfiguration } from '../../../redux/Configuration/actions';

const ActiveConfigButton = ({ isActive, _id }) => {
  const dispatch = useDispatch();

  const onChange = (checked) => {
    if (checked) {
      dispatch(fetchActiveConfigIdForMachine(_id));
    } else {
      dispatch(updateConfiguration(_id, { isActive: false }));
    }
  };

  return (
    <Switch checked={isActive} onChange={onChange} size="small" defaultChecked />
  );
};

export default ActiveConfigButton;
